
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    aiName: {
      type: String,
      required: true,
    },
  },
});
